var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.448 10.235V18.815C22.448 19.725 22.398 20.625 22.298 21.515C22.208 22.405 22.078 23.33 21.908 24.29H19.118C18.948 23.33 18.813 22.405 18.713 21.515C18.623 20.625 18.578 19.725 18.578 18.815V10.235H22.448ZM18.023 29.825C18.023 29.495 18.083 29.185 18.203 28.895C18.333 28.595 18.508 28.34 18.728 28.13C18.948 27.91 19.203 27.74 19.493 27.62C19.793 27.49 20.118 27.425 20.468 27.425C20.808 27.425 21.123 27.49 21.413 27.62C21.713 27.74 21.973 27.91 22.193 28.13C22.413 28.34 22.588 28.595 22.718 28.895C22.848 29.185 22.913 29.495 22.913 29.825C22.913 30.165 22.848 30.48 22.718 30.77C22.588 31.06 22.413 31.315 22.193 31.535C21.973 31.745 21.713 31.91 21.413 32.03C21.123 32.15 20.808 32.21 20.468 32.21C20.118 32.21 19.793 32.15 19.493 32.03C19.203 31.91 18.948 31.745 18.728 31.535C18.508 31.315 18.333 31.06 18.203 30.77C18.083 30.48 18.023 30.165 18.023 29.825Z",
    fill: "#CECECE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 19,
    stroke: "#CECECE",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.91ced7480187799f0408cf699f0ddc83.svg";
export { ForwardRef as ReactComponent };